
<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">
               
              
<app-address [showSameAsMailingLink]=true (parentFun)="parentFun($event)" [addressType]="billing"></app-address>
</div>
        </div>
    </div>
</div>
